import { SubscriptionCredentials, SubscriptionCredentialsProps } from '@nx-smartmonkey/shared/domain';

export class DriversSubscriptionCredentials extends SubscriptionCredentials {
  isSoloDriversPlan(): boolean {
    return this.test(`drivers.solo_drivers`);
  }

  isDriversLitePlan(): boolean {
    return this.test(`drivers.unlimited_stops`);
  }

  static override create(props: SubscriptionCredentialsProps): DriversSubscriptionCredentials {
    return new DriversSubscriptionCredentials(props);
  }
}
